/**
 * Types for admin ministries feature.
 */

export interface AdminMinistriesFilter {
  isActive?: boolean;
}

export interface AdminMinistryListItem {
  id: string;
  code: string;
  name: string;
  description: string | null;
  imageUrl: string | null;
  isActive: boolean;
  sortOrder: number;
  memberCount: number;
}

export type MinistryRole = "MEMBER" | "LEADER" | "ADMIN";

const MINISTRY_ROLE_LABELS: Record<MinistryRole, string> = {
  MEMBER: "Участник",
  LEADER: "Лидер",
  ADMIN: "Админ",
};

export function ministryRoleLabel(role: MinistryRole): string {
  return MINISTRY_ROLE_LABELS[role] ?? role;
}

export const MINISTRY_ROLE_OPTIONS: { value: MinistryRole; label: string }[] = [
  { value: "MEMBER", label: "Участник" },
  { value: "LEADER", label: "Лидер" },
  { value: "ADMIN", label: "Админ" },
];
